import { Country } from 'App/i18n/enums';
import { useCountry, useFeatureFlag } from 'commons/hooks';
import { FeatureFlag } from 'commons/services';

export const useShowReportsColumn = (
  countries: Country[] = [Country.MEXICO],
): boolean => {
  const { storeCountry } = useCountry();
  const { enabled: featureFlagEnabled } = useFeatureFlag(
    FeatureFlag.FS_PAGONUBE_BATCH_PROCESS_BALANCE_TRANSACTIONS_ENABLED,
  );

  return countries.includes(storeCountry) && featureFlagEnabled;
};
